import React, { useMemo, useState } from "react";
import Card from "../card/Card";
import Pagination from "../pagination/Pagination";

import Select from "../select/Select";

let PageSize = 12;

const ProductList = ({ data = [], isAuthorized }) => {
  // const [currentPage, setCurrentPage] = useState(1);
  // const currentTableData = useMemo(() => {
  //   const firstPageIndex = (currentPage - 1) * PageSize;
  //   const lastPageIndex = firstPageIndex + PageSize;
  //   return data.slice(firstPageIndex, lastPageIndex);
  // }, [currentPage]);

  if (!Array.isArray(data)) {
    return null;
  }

  return (
    <div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-2 md:gap-3 lg:gap-3">
        {data.map((item, index) => (
          <Card key={item.id || index} data={item} isAuthorized={isAuthorized} />
        ))}
      </div>
      {/* <Pagination
        className="pagination-bar"
        currentPage={currentPage}
        totalCount={data.length}
        pageSize={PageSize}
        onPageChange={page => setCurrentPage(page)}
      /> */}
    </div>
  );
};

export default ProductList;
